import type { ReactElement } from 'react';

import { Box } from '@/components/Box';
import { Button } from '@/components/Button';
import { Col } from '@/components/Col';
import { Grid } from '@/components/Grid';
import { OrderStatusStepper } from '@/components/MyOrders/OrderStatusStepper';
import type { FulfillmentStatus } from '@/components/MyOrders/ReturnedOrders/ReturnOrderStatusStepper';
import { ReturnOrderStatusStepper } from '@/components/MyOrders/ReturnedOrders/ReturnOrderStatusStepper';
import type { OrderAppOrderStatus } from '@/graphql/orderApp/api';
import * as OM from '@/messages/order';

import { useOrderDetailsContext } from '../OrderDetailsContext';

export function OrderStatusStepperSection(): ReactElement {
  const ctx = useOrderDetailsContext();
  const {
    deliveryMode,
    fulfillment,
    hasFulfillment,
    isHomeDelivery,
    isMobileView,
    order,
    orderStatus,
    paths,
    push,
    showStatusStepper,
    trackingLink,
  } = ctx;

  const returnStatus = fulfillment?.returnStatus as
    | FulfillmentStatus
    | null
    | undefined;

  const onTrackOrder = () =>
    push(
      `${paths.tracking.asPath()}?comingFromSearch=${true}&orderNo=${
        order.businessId
      }`,
    );

  return (
    <Box paddingBottom={3} paddingTop={3}>
      <Grid
        gridAutoFlow={isMobileView ? 'row' : 'column'}
        justifyContent='space-between'
      >
        {hasFulfillment ? (
          <Col md={10} xs={12}>
            <ReturnOrderStatusStepper
              data-test-id='OrderDetailsViewReturnOrderStatusStepper'
              status={returnStatus as FulfillmentStatus}
            />
          </Col>
        ) : (
          <>
            {showStatusStepper ? (
              <>
                <Col md={10} style={{ overflow: 'auto' }} xs={12}>
                  <OrderStatusStepper
                    data-test-id='OrderDetailsViewOrderStatusStepper'
                    deliveryMode={deliveryMode}
                    status={orderStatus as OrderAppOrderStatus}
                  />
                </Col>
                {isHomeDelivery ? (
                  <Col md={2} xs={12}>
                    <Button
                      data-test-id='OrderDetailsViewTrackMyOrderButton'
                      disabled={!trackingLink}
                      isFullWidth
                      onClick={onTrackOrder}
                      rel='noopener noreferrer'
                    >
                      {OM.TrackMyOrder}
                    </Button>
                  </Col>
                ) : null}
              </>
            ) : null}
          </>
        )}
      </Grid>
    </Box>
  );
}
